/** 本地只读备份流水快照仓储（不触碰钱包 / 账本写接口）。 */
import type { BackupLedgerEntry } from '../../core/db';
import { getDb } from '../../core/db';

export async function listBackupLedgerEntries(userId: string): Promise<BackupLedgerEntry[]> {
  const rows = await getDb().backupLedgerEntries.where('userId').equals(userId).toArray();
  return rows.sort((a, b) => b.capturedAt - a.capturedAt || (a.entry.createdAt < b.entry.createdAt ? 1 : -1));
}

export async function countBackupLedgerEntries(userId: string): Promise<number> {
  return getDb().backupLedgerEntries.where('userId').equals(userId).count();
}
